import React from 'react';
import { getStrings } from '@/helpers/utils';
import Form from './Components/Form';
import FormikHOC from './Components/FormikHOC';
import AccountWrapper from '../../../wrappers/AccountWrapper/AccountWrapper';
import { FormWrapper } from '../PromotionsNotifications/styles/PromotionsNotifications.styles';

const TakeABreakForm: React.FC = () => {
  const [
    {
      Account: {
        TakeABreak: { pageTitle },
      },
    },
  ] = getStrings();

  return (
    <AccountWrapper pageTitle={pageTitle} pageHeader={pageTitle}>
      <FormikHOC>
        <FormWrapper>
          <Form />
        </FormWrapper>
      </FormikHOC>
    </AccountWrapper>
  );
};

export default TakeABreakForm;
